import React from 'react';
import Comics from '../Components/Comics';

const ComicsPage = () => (
  <div>
    <Comics />
  </div>
);

export default ComicsPage;
